<div class="double-slider">
  @if (lowSliderValue === highSliderValue) {
    <div>
      <span class="double-slider__title-primary">{{lowSliderValue}}</span>
      @if (lowSliderValue === 1) {
        <span class="double-slider__title-secondary"> time</span>
      }
      @if (lowSliderValue !== 1) {
        <span class="double-slider__title-secondary"> times</span>
      }
    </div>
  }
  @if (lowSliderValue !== highSliderValue) {
    <div>
      <span class="double-slider__title-secondary">Between </span>
      <span class="double-slider__title-primary">{{lowSliderValue}}</span>
      <span class="double-slider__title-secondary"> and </span>
      <span class="double-slider__title-primary">{{highSliderValue}}</span>
      <span class="double-slider__title-secondary"> times</span>
    </div>
  }
  <ngx-slider [(value)]="filter.sliderOptions.value"
    [(highValue)]="filter.sliderOptions.highValue"
    [options]="filter.sliderOptions"
    (valueChange)="updateSliderLowValue($event)"
    (highValueChange)="updateSliderHighValue($event)"
    (userChangeEnd)="updateTwoVariableSliderValue(filter)">
  </ngx-slider>
</div>
